import Tag from './NewTag';

export default Tag;
